import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Card from '../../common/components/Card';
import { useGlobal } from 'reactn';

const Wrapper = styled.div`
  color: initial;
`;

const FinanceReports = () => {
  const [config] = useGlobal('config');
  const reports = JSON.parse(config['finance-reports'] || '[]');
  const itemTitleClass = 'text-gray-800 line-clamp-2';
  const itemTextClass = 'text-gray-600 line-clamp-2';

  return (
    <Card floating padded={false} bodyBackground="none" title="Reports">
      <div className="pb-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {reports.map(report => {
          switch (report) {
            case 'weeklyTimesheetSnapshots':
              return (
                <Link
                  key={report}
                  to="/finance/reports/weekly-snapshot"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Weekly Timesheet Snapshot</h2>
                    <p className={itemTextClass}>
                      Show weekly tasks and hours for all employees for a given range.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'dailyTimesheetSnapshots':
              return (
                <Link
                  to="/finance/reports/daily-snapshot"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Daily Timesheet Snapshot</h2>
                    <p className={itemTextClass}>
                      Show daily tasks and hours for all employees for a given range.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'payrollAllocation':
              return (
                <Link
                  key={report}
                  to="/finance/reports/payroll-allocation"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Payroll Allocation</h2>
                    <p className={itemTextClass}>
                      Generate employee allocation report for payroll submission.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'timeOffReport':
              return (
                <Link
                  key={report}
                  to="/finance/reports/timeoff"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Time Off Report</h2>
                    <p className={itemTextClass}>Generate employee time off report.</p>
                  </Wrapper>
                </Link>
              );
            case 'quickbooksExport':
              return (
                <Link
                  key={report}
                  to="/finance/reports/quickbooks-export"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Quickbooks Export</h2>
                    <p className={itemTextClass}>
                      Export timesheet data for the purposes of importing into Quickbooks desktop
                      edition.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'missingTimesheetsByWeek':
              return (
                <Link
                  key={report}
                  to="/finance/reports/missing-timesheets"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Missing Timesheets By Week</h2>
                    <p className={itemTextClass}>
                      Identify and list all missing timesheets for each week.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'projects':
              return (
                <Link
                  key={report}
                  to="/finance/reports/projects"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Projects</h2>
                    <p className={itemTextClass}>Show all projects and relevant details.</p>
                  </Wrapper>
                </Link>
              );
            case 'wip':
              return (
                <Link
                  key={report}
                  to="/finance/reports/wip"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Work in Progress Report</h2>
                    <p className={itemTextClass}>
                      Work-in-progress revenue recognition by project for a reporting month.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'customReports':
              return (
                <Link
                  key={report}
                  to="/finance/reports/custom"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Custom Reports</h2>
                    <p className={itemTextClass}>Create customizable reports with advanced filtering and grouping options.</p>
                  </Wrapper>
                </Link>
              );
            case 'ptoAllocationReport':
              return (
                <Link
                  key={report}
                  to="/finance/reports/pto-allocation"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>PTO Allocation Report</h2>
                    <p className={itemTextClass}>
                      Show daily tasks and hours for all employees for a given range.
                    </p>
                  </Wrapper>
                </Link>
              );
            case 'timesheetLatenessByWeek':
              return (
                <Link
                  key={report}
                  to="/finance/reports/timesheet-lateness"
                  className="h-full border rounded-lg shadow-sm hover:shadow-md transition flex flex-col bg-white"
                >
                  <Wrapper className="text-initial flex-1 flex flex-col p-6">
                    <h2 className={itemTitleClass}>Timesheet Lateness By Week</h2>
                    <p className={itemTextClass}>
                      Track weekly late submissions and average lateness.
                    </p>
                  </Wrapper>
                </Link>
              );
            default:
              return null;
          }
        })}
      </div>
    </Card>
  );
};

export default FinanceReports;
